import React from 'react';

import { PrimitivesProvider } from '@change/ds-primitives';

import { DSLink } from './components/DSLink';

type Props = { children: React.ReactNode };

// using a const because of a hook dep in the usePrimitive hook implementation
// TODO improve usePrimitive implementation to avoid this issue
const primitives = { a: DSLink };

export const DSPrimitivesProvider: React.FC<Props> = ({ children }: Props) => (
	<PrimitivesProvider primitives={primitives}>{children}</PrimitivesProvider>
);
